import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneInvitation,
  GET_ONE_INVITATION,
  GET_ONE_INVITATION_ERROR,
  GET_ONE_INVITATION_SUCCESS,
} from '../types/invitation/get-one'

import {
  GetAllInvitations,
  GET_ALL_INVITATIONS,
  GET_ALL_INVITATIONS_ERROR,
  GET_ALL_INVITATIONS_SUCCESS,
  UPDATE_INVITATIONS,
} from '../types/invitation/get-all'

import {
  NewInvitation,
  NEW_INVITATION,
  NEW_INVITATION_ERROR,
  NEW_INVITATION_SUCCESS,
} from '../types/invitation/new'

import {
  EditInvitation,
  EDIT_INVITATION,
  EDIT_INVITATION_ERROR,
  EDIT_INVITATION_SUCCESS,
} from '../types/invitation/edit'

import {
  DeleteInvitation,
  DELETE_INVITATION,
  DELETE_INVITATION_ERROR,
  DELETE_INVITATION_SUCCESS,
} from '../types/invitation/delete'

const currentInvitationTypeChildren = ({ invitationStore }) => invitationStore.all.data

function* getOneInvitation({ payload }) {
  try {
    const { response, error } = yield call(services.invitation.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_INVITATION_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_INVITATION_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_INVITATION_ERROR,
      payload: 'Error al obtener contendio',
    })
  }
}

function* getAllInvitations({ payload }) {
  try {
    const { response, error } = yield call(services.invitation.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_INVITATIONS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_INVITATIONS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_INVITATIONS_ERROR,
      payload: 'Error al obtener los contenidos',
    })
  }
}

function* newInvitation({ payload }) {
  try {
    const { response, error } = yield call(services.invitation.new, payload)

    if (error) {
      yield put({
        type: NEW_INVITATION_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({
          type: NEW_INVITATION_SUCCESS,
          payload: response,
        })
      ])
    }
  } catch {
    yield put({
      type: NEW_INVITATION_ERROR,
      payload: 'Error al crear nuevo contenido',
    })
  }
}

function* editInvitation({ payload }) {
  try {
    const { response, error } = yield call(services.invitation.edit, payload)
    if (error) {
      yield put({
        type: EDIT_INVITATION_ERROR,
        payload: error,
      })
    } else {
      const currentInvitations = yield select(currentInvitationTypeChildren)
      const updatedInvitations = currentInvitations?.data?.map(invitation => {
        if (invitation?._id === response?._id) {
          return response
        } else {
          return invitation
        }
      })

      yield all([
        put({
          type: EDIT_INVITATION_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_INVITATIONS,
          payload: updatedInvitations,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_INVITATION_ERROR,
      payload: 'Error al editar el contenido.',
    })
  }
}

function* deleteInvitation({ payload }) {
  try {
    const { response, error } = yield call(services.invitation.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_INVITATION_ERROR,
        payload: error,
      })
    } else {
      const currentInvitations = yield select(currentInvitationTypeChildren)
      const updatedInvitations = currentInvitations?.data?.map(invitation => {
        if (invitation?._id === response?._id) {
          return response
        } else {
          return invitation
        }
      })

      yield all([
        put({
          type: DELETE_INVITATION_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_INVITATIONS,
          payload: updatedInvitations,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_INVITATION_ERROR,
      payload: 'Error al eliminar contenido',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneInvitation>(GET_ONE_INVITATION, getOneInvitation)
  yield takeLatest<GetAllInvitations>(GET_ALL_INVITATIONS, getAllInvitations)
  yield takeLatest<NewInvitation>(NEW_INVITATION, newInvitation)
  yield takeLatest<EditInvitation>(EDIT_INVITATION, editInvitation)
  yield takeLatest<DeleteInvitation>(DELETE_INVITATION, deleteInvitation)
}
